import { animate, style, transition, trigger } from "@angular/animations";

export class CustomAnimations {
    static fadeIn = (duration: string) =>
        trigger("fadeIn", [
            transition(":enter", [style({ opacity: 0 }), animate(duration, style({ opacity: 1 }))]),
            transition(":leave", [animate(duration, style({ opacity: 0 }))])
        ]);
}
